import * as bootstrap from 'bootstrap';
import {cookies} from "./cookies.class";


if (document.querySelector('#newsletterPopupModal')) {
  const modalPopup = new bootstrap.Modal(document.querySelector('#newsletterPopupModal'))

  if (cookies.get('brokat_newsletter_popup') !== '1') modalPopup.show()

  document.querySelector('#newsletterPopupModal').addEventListener('hidden.bs.modal', function() {
    cookies.set('brokat_newsletter_popup', '1', 30);
  })
}

